const t = {
  name: "Bin",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.5 9V19H8.5V9H10.5Z" fill="currentColor"/>
<path d="M13.5 9H15.5V19H13.5V9Z" fill="currentColor"/>
<path d="M16.28 4L15.85 2.27C15.52 0.93 14.32 0 12.94 0H11.06C9.68 0 8.48 0.93 8.15 2.27L7.72 4H2V6H3.55L4.4 21.17C4.49 22.76 5.81 24 7.4 24H16.62C18.21 24 19.53 22.76 19.62 21.17L20.47 6H22.01V4H16.28ZM10.09 2.75C10.2 2.31 10.6 2 11.06 2H12.94C13.4 2 13.8 2.31 13.91 2.75L14.22 4H9.78L10.09 2.75ZM17.62 21.05C17.59 21.58 17.15 22 16.62 22H7.4C6.87 22 6.43 21.58 6.4 21.05L5.56 6H18.46L17.62 21.05Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Bin
};
